import { SplitFactory } from "@splitsoftware/splitio-browserjs";
import { win } from "./pd-window";
import { segmentAnonId } from "../segment/helpers.js";
import { uuid } from "./uuid.js";
import { getParameterByName } from "./url-helpers.js";

const productionSplitAuthKey = "vmaj3t55f6db144va0d2qc7nt6a50cpir96k";
const stagingSplitAuthKey = "3vumrvvtmuh50fo5hjr16usdpjcs40v2lvha";
const defaultSplitAuthKey =
  document.location.hostname === "www.pagerduty.com"
    ? productionSplitAuthKey
    : stagingSplitAuthKey;

/**
 * @typedef {Object} SplitTestInit
 * @prop {(variationId: string) => void} setViewTreatment
 * @prop {() => void} setDefaultViewTreatment
 * @prop {string} experimentId
 * @prop {string} [splitAuthKey] Optional. Defaults to `defaultSplitAuthKey`
 */

/** @arg {SplitTestInit} splitTest */
export function createSplitTest({
  splitAuthKey,
  experimentId,
  setDefaultViewTreatment,
  setViewTreatment,
}) {
  // For debugging purposes:
  // If a query string parameter is present use it to choose the treatment
  // instead of split. e.g.: http://../?arm=control
  const arm = getParameterByName("arm");
  if (arm != null) {
    setViewTreatment(arm);
    return;
  }

  // Both segment and split can fail (gdpr, ad blocker)
  // On failure the control variant is set
  try {
    if (win.analytics == null) throw new Error("analytics not available");

    // Get segment's anonymous id if it exists
    let splitKey = segmentAnonId();
    if (splitKey == null) {
      // Otherwise create it
      splitKey = /** @type {string} */ (uuid());
      // And let segment know about it as there might be calls before split loads
      segmentAnonId(splitKey);
    }

    const factory = SplitFactory({
      core: {
        authorizationKey: splitAuthKey ?? defaultSplitAuthKey,
        key: splitKey, // segment's anon id
      },
      startup: {
        readyTimeout: 1.5, // seconds
      },
    });
    const client = factory.client();
    client.on(client.Event.SDK_READY, function () {
      const variationId = client.getTreatment(experimentId);
      setViewTreatment(variationId);
      // Record the delay to show the variation view in Segment
      if (win.pd.startTime != null) {
        const durationMs = Date.now() - win.pd.startTime; // Time the flash
        win.analytics.track &&
          win.analytics.track("Split flash time", {
            durationMs,
            experimentId,
            variationId,
          });
      }
      client.destroy();
    });
  } catch (err) {
    setDefaultViewTreatment();
  }
}
